rdefine('app/stores/hoursSpecial',['backbone','text!stores/hoursSpecial.html','app/stores/hoursSpecialModal','text!stores/hoursMainRow.html'],function(Backbone,template,HoursSpecialModal,templateRowMain) {
    var timeMainView = Backbone.Ribs.View.extend({
        tagName:'li',
        bindings:{
            el:{
                text:{
                    data:['model.ftime','model.stime'],
                    processor:function(f,s) {
                        if(f===s && f === "00:00") {
                            return window.LANGUAGE['stores.hours.24'];
                        }
                        return (f ? f : "")  + ' - ' + (s ? s : "");
                    }
                }
            }
        }
    });

    var DatesView = Backbone.Ribs.View.extend({
        bindings:{
            '.c-monday .text-right span':{
                text:{data:'model.date',
                processor:function(a){
                    return a.length ? moment(a).format("DD.MM.YYYY") : '-';
                }}
            },
            '.on-off':{
                toggle:{
                    data:'model.enabled',
                    processor:function(a) { return !a; }
                }
            },
            '.hours-list':{
                collection:{
                    col:'collect',
                    view:timeMainView
                },
                toggle:{
                    data:'model.enabled'
                }
            }
        },
        initialize:function(options) {
            console.log(options.model.attributes);
            this.$el.html(Template7.compile(templateRowMain)());
            this.collect = new Backbone.Ribs.Collection(this.model.get("times"),{model:Backbone.Ribs.Model});
             this.model.collection.on("packit",this.unpackModelToCol.bind(this));
        },
        unpackModelToCol:function() {
            console.log("CC",this.model.get("times"));
            this.collect.reset(this.model.get('times'));
        }
    });

    var HoursModel = Backbone.Ribs.Model.extend({
        defaults:{
            date:'',
            enabled:false,
            times:[]
        }
    });


    return Backbone.Ribs.View.extend({
        className:'hours-place',
        input:null,
        bindings:{
            '.store-center-message':{
                toggle:{
                    data:'model.lcol',
                    processor:function (a) {
                        return !a;
                    }
                }
            },
            '.list-of-dates':{
                toggle:'model.lcol',
                collection:{
                    col:'col',
                    view:DatesView
                }
            }
        },
        events:{
            "click .hover-content":"openModal"
        },
        initialize:function(options) {
            this.input = options.input;
            this.$el.html(Template7.compile(template)());
            this.model = new Backbone.Ribs.Model({lcol:0});
            this.col = new Backbone.Ribs.Collection([],{model:HoursModel});
            this.col.on("add remove packit",this.packInput.bind(this));

            this.modal=new ModalWrapper({
                content:HoursSpecialModal,
                title:window.LANGUAGE['stores.hours.specials'],
                config:{
                    collection:this.col,
                    controller:this
                },
                buttons:[
                    {
                        'id':'save',
                        title:window.LANGUAGE['statistics.modal.close'],
                        style:'btn-primary',
                        cbs:[],
                        event:'close'
                    }
                ]
            });

            this.unpackInput();
        },
        packInput:function() {
            this.model.set("lcol",this.col.length);
            var pack = [];
            for(var i in this.col.models) {
                pack.push(this.col.models[i].attributes);
            }
            console.log("PACK",pack);
            this.input.val(JSON.stringify(pack));
        },
        unpackInput:function() {
            try {
                var j = JSON.parse(this.input.val());
                console.log("UNPOACK",j);
                if(j) {
                    this.col.reset(j);
                }
            } catch (e) {
                this.col.reset([]);
            }
            this.model.set("lcol",this.col.length);
        },
        openModal:function() {
            this.modal.show();
        }
    });
});